module.exports = __webpack_public_path__ + "static/logo@2x-dfb7ab69e47e35ce1356b0d44071d408.png";